/* =====================================================================
   INDUCTION HARDWARE — BLOG POST INTERACTIONS
   Reading-progress bar, share actions, newsletter toast, scroll reveal.
   Vanilla JS, no dependencies. (Nav/mobile-menu is handled by the theme
   header.)
===================================================================== */
(function () {
  /* ---------- Reading progress ---------- */
  var bar = document.getElementById('readProgress');
  var article = document.querySelector('.article');
  if (bar && article) {
    var update = function () {
      var rect = article.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var scrolled = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
      bar.style.width = (total > 0 ? (scrolled / total) * 100 : 0) + '%';
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Toast ---------- */
  var toast = document.getElementById('toast');
  var toastMsg = toast ? toast.querySelector('span') : null;
  function showToast(msg) {
    if (!toast) return;
    if (toastMsg && msg) toastMsg.textContent = msg;
    toast.classList.add('show');
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () { toast.classList.remove('show'); }, 2400);
  }

  /* ---------- Share buttons ---------- */
  var shareRow = document.querySelector('.share__row');
  if (shareRow) {
    var url = (function () {
      var canon = document.querySelector('link[rel="canonical"]');
      return canon ? canon.href : window.location.href;
    })();
    var title = document.title;
    shareRow.querySelectorAll('[data-share]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var kind = btn.getAttribute('data-share');
        var u = encodeURIComponent(url), t = encodeURIComponent(title);
        var target = '';
        if (kind === 'facebook') target = 'https://www.facebook.com/sharer.php?u=' + u;
        else if (kind === 'twitter') target = 'https://twitter.com/intent/tweet?text=' + t + '&url=' + u;
        else if (kind === 'pinterest') target = 'https://pinterest.com/pin/create/button/?url=' + u + '&description=' + t;
        else if (kind === 'email') { window.location.href = 'mailto:?subject=' + t + '&body=' + u; return; }
        else if (kind === 'copy') {
          if (navigator.clipboard) navigator.clipboard.writeText(url);
          showToast('Link copied');
          return;
        }
        window.open(target, '_blank', 'noopener,width=620,height=540');
      });
    });
  }

  /* ---------- Newsletter (demo toast; wire to real endpoint) ---------- */
  var nlForm = document.getElementById('newsletterForm');
  if (nlForm) {
    nlForm.addEventListener('submit', function (e) {
      e.preventDefault();
      showToast("You're subscribed");
      nlForm.reset();
    });
  }

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }
})();
